/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { IComponentAs, IComponentAsProps, DefaultButton, PrimaryButton } from "@fluentui/react";
import { CommandBar, ICommandBarItemProps } from "@fluentui/react/lib/CommandBar";
import { IGridActionsProps } from "./GridModels";
import "./GridCommandBar.css";

export const GridCommandBar = (props: IGridActionsProps): JSX.Element => {
    return (
        <nav>
            <CommandBar
                className="commandBar"
                items={props.left}
                farItems={props.right ?? []}
                ariaLabel="Actions"
            />
        </nav>
    );
};

export const CancelButtonWrapper: IComponentAs<ICommandBarItemProps> = (
    props: IComponentAsProps<ICommandBarItemProps>
) => {
    const clickHandler = () => {
        if (props.onClick) props.onClick();
    };
    return <DefaultButton text={props.text} styles={props.styles} onClick={clickHandler} />;
};

export const SaveButtonWrapper: IComponentAs<ICommandBarItemProps> = (
    props: IComponentAsProps<ICommandBarItemProps>
) => {
    const clickHandler = () => {
        if (props.onClick) props.onClick();
    };
    return (
        <PrimaryButton
            text={props.text}
            styles={props.styles}
            disabled={props.disabled}
            onClick={clickHandler}
        />
    );
};
